/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Beitragsgruppenschluesselrv2Inputs */



/**

* @param {_Field_Beitragsgruppenschluesselrv2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_beitragsgruppenschluesselrv2 = /** @type {((inputs?: _Field_Beitragsgruppenschluesselrv2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Beitragsgruppenschluesselrv2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Beitragsgruppenschlüssel RV")
});
export { _field_beitragsgruppenschluesselrv2 as "_field_beitragsgruppenschluesselRV" }